import { IGameAttendancesVotes } from "@grassrootly/api/entities/IGameAttendancesVotes";
import { provider } from "@grassrootly/api/providers";

export type GetGameVotesPayload = {
  gameId: number;
};

export const GetGameVotes = async (params: GetGameVotesPayload): Promise<{ votes: IGameAttendancesVotes[], playerVoted: number }> =>
  provider.Request("/game/votes", params);
